// Google Ads 전환 헬퍼 — gtag 미로드(광고차단기·SW 구버전)여도 가입 흐름을 막으면 안 된다
// ID·라벨 출처: docs/marketing/google-ads-account.md
const AW_SEND_TO = "AW-18316808737/-h6vCMiN8s4cEKGkkZ5E";

export function reportSignupConversion() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return false;
  window.gtag("event", "conversion", { send_to: AW_SEND_TO });
  return true;
}
